import React from 'react';
import PropTypes from 'prop-types';
import RichText from '../../rich-text/base';

// Utils
import { propLink } from '../../link-handler';
import { ImageProps, RichTextPropTypes } from '../../../prop-types';
import { replaceLineBreakShortCode } from '../../../utils/replace-shortcode-br';
import { consistentString } from '../../../utils/content-formatting';

// Styles
import { sizes } from '../../theme/breakpoint';
import {
  StyledContainer,
  Title,
  Wrapper,
  BannerContent,
  MediaContainer,
  MobileContent,
  DesktopContent,
  StyledCTA,
} from './styles';

const MadeInSocialHousingImagesHero = ({ content }) => {
  const { title, contentBlockOne, imageOne, imageTwo, ctaOne } = content;

  const generateImage = (image, size, widthType = 'max') => (
    <>
      <source
        media={`(${widthType}-width: ${size}px)`}
        srcSet={`${image.file.url}?fm=avif&fit=scale&w=${size}`}
        type="image/avif"
      />
      <source
        media={`(${widthType}-width: ${size}px)`}
        srcSet={`${image.file.url}?fm=webp&fit=scale&w=${size}`}
        type="image/webp"
      />
    </>
  );

  return (
    <Wrapper $variant="images">
      <StyledContainer>
        <BannerContent>
          <Title>{replaceLineBreakShortCode(title)}</Title>
          {contentBlockOne ? <RichText richText={contentBlockOne} /> : null}
          {ctaOne ? (
            <DesktopContent>
              <StyledCTA
                bg={consistentString(ctaOne.ctaColor)}
                link={ctaOne.link}
              >
                {ctaOne.buttonText}
              </StyledCTA>
            </DesktopContent>
          ) : null}
        </BannerContent>
        {imageOne ? (
          <MediaContainer $hasWideImage={!!imageTwo}>
            <picture>
              {/* Mobile: Up to 512px */}
              {generateImage(imageOne, sizes.mobileLand)}

              {/* Tablet / Desktop: Up to 1170px */}
              {generateImage(imageOne, sizes.tablet)}

              {/* Wide Desktop: 1170px and above */}
              {generateImage(imageTwo || imageOne, sizes.desktopWide, 'min')}
              <img
                src={`${imageOne.file.url}?fm=jpg&fl=progressive&q=80`}
                alt={imageOne.description}
                width={sizes.desktopWide}
              />
            </picture>
          </MediaContainer>
        ) : null}
        {ctaOne ? (
          <MobileContent>
            <BannerContent>
              <StyledCTA
                bg={consistentString(ctaOne.ctaColor)}
                link={ctaOne.link}
              >
                {ctaOne.buttonText}
              </StyledCTA>
            </BannerContent>
          </MobileContent>
        ) : null}
      </StyledContainer>
    </Wrapper>
  );
};

MadeInSocialHousingImagesHero.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    contentBlockOne: RichTextPropTypes,
    imageOne: ImageProps,
    imageTwo: ImageProps,
    ctaOne: PropTypes.shape({
      ctaColor: PropTypes.string.isRequired,
      buttonText: PropTypes.string.isRequired,
      link: propLink.isRequired,
    }),
  }),
};

export default MadeInSocialHousingImagesHero;
